// extracted by mini-css-extract-plugin
export default {"tooltip":"JV-z","arrow":"KV-z"};